import script from "./CensusModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CensusModal.vue?vue&type=script&setup=true&lang=ts"

import "./CensusModal.vue?vue&type=style&index=0&id=7cb9f5c2&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb9f5c2"]])

export default __exports__